import { render, staticRenderFns } from "./BldForm.vue?vue&type=template&id=6c4304d4&scoped=true&"
import script from "./BldForm.vue?vue&type=script&lang=js&"
export * from "./BldForm.vue?vue&type=script&lang=js&"
import style0 from "./BldForm.vue?vue&type=style&index=0&id=6c4304d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4304d4",
  null
  
)

export default component.exports